import { Box, Paper } from '@mui/material';
import { Button } from '@apigrowfinance/pbolt-button';
import { FormattedMessage } from 'react-intl';

import ConditionsShared from '@pages/flexControls/shared/ConditionsForm';
import getEnumTranslation from '@utils/getEnumTranslation';

interface ConditionsProps {
    goToPreviousStep?: () => void;
    submit?: () => void;
    isSubmitting: boolean;
    attributes: string[];
    operators: string[];
}

const Conditions = ({
    goToPreviousStep,
    submit,
    isSubmitting,
    attributes,
    operators,
}: ConditionsProps) => {
    return (
        <Paper
            elevation={0}
            sx={{
                mt: 2,
                p: 2,
                pt: 5.5,
            }}>
            <ConditionsShared
                attributes={attributes}
                operators={operators}
                isEditing={false}
            />

            <Box
                display="flex"
                flexDirection="row"
                justifyContent="flex-end"
                sx={{ mt: 2 }}>
                <Button
                    onClick={goToPreviousStep}
                    name="positive"
                    role="button"
                    variant="outlined"
                    disableElevation
                    data-testid="conditions-form-previous-button"
                    sx={{
                        px: 8,
                        textTransform: 'none',
                    }}>
                    {getEnumTranslation('previous')}
                </Button>
                <Button
                    disabled={isSubmitting}
                    onClick={submit}
                    name="positive"
                    role="button"
                    variant="contained"
                    disableElevation
                    data-testid="conditions-form-submit-button"
                    sx={{
                        ml: 1,
                        px: 8,
                        textTransform: 'none',
                    }}>
                    <FormattedMessage
                        id="Conditions.addNewControl"
                        defaultMessage="Add new control"
                    />
                </Button>
            </Box>
        </Paper>
    );
};

export default Conditions;
